'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _getDisplayName = require('helpers/getDisplayName');

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (ComponentToWrap, props) {
  var _class, _temp;

  var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var WrappedComponent = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(WrappedComponent, _Component);

    function WrappedComponent() {
      (0, _classCallCheck3.default)(this, WrappedComponent);
      return (0, _possibleConstructorReturn3.default)(this, (WrappedComponent.__proto__ || (0, _getPrototypeOf2.default)(WrappedComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(WrappedComponent, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _props = this.props,
            currentComponent = _props.component,
            currentIsSelected = _props.isSelected;
        var nextComponent = nextProps.component,
            nextIsSelected = nextProps.isSelected;


        return currentComponent !== nextComponent || nextIsSelected !== currentIsSelected;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            components = _props2.components,
            component = _props2.component,
            restProps = (0, _objectWithoutProperties3.default)(_props2, ['components', 'component']);


        if (!component) return null;

        var childComponents = component.childComponents && component.childComponents.map(function (child) {
          return components[child];
        }) || null;

        return _react2.default.createElement(ComponentToWrap, (0, _extends3.default)({}, component, restProps, { childComponents: childComponents, components: components }));
      }
    }]);
    return WrappedComponent;
  }(_react.Component), _class.displayName = 'modal-connected-' + (0, _getDisplayName2.default)(ComponentToWrap), _class.propTypes = {
    component: _react.PropTypes.object.isRequired,
    components: _react.PropTypes.object.isRequired,
    isSelected: _react.PropTypes.bool
  }, _class.defaultProps = {
    isSelected: false
  }, _temp);


  var mapStateToProps = function mapStateToProps(state) {
    var templates = state.templateApplication.templates;
    var template = state.templateApplication.templates.currentTemplate;
    var components = state.templateApplication.templates.currentTemplate.components;
    var component = components && components[props.id];
    var isSelected = template.selectedComponent === props.id;

    return { component: component, components: components, isSelected: isSelected, templates: templates };
  };

  return (0, _reactRedux.connect)(mapStateToProps, actions)(WrappedComponent);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/wrapTemplateComponent/wrapTemplateComponent.jsx
// module id = 1652
// module chunks = 0